/* Shambhavi V2 · one small script, no libraries.
   header hide/show · menu sheet · reveal · hero intro · scroll story (+ embers) · tabs ·
   AJAX add-to-cart (cards + product form) with cart count · product gallery / qty / options /
   accordion / sticky bar / pincode note. Re-binds when a section reloads in the theme editor. */
(function () {
  "use strict";
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches;
  var EDIT = !!(window.Shopify && Shopify.designMode);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  /* ---------------------------------------------------------- header */
  function header() {
    var h = $("[data-sc2-hdr]"); if (!h || h.dataset.bound) return; h.dataset.bound = 1;
    var last = scrollY;
    addEventListener("scroll", function () {
      var y = scrollY;
      h.classList.toggle("is-hidden", y > last && y > 400 && !document.documentElement.classList.contains("sc2-lock"));
      last = y;
    }, { passive: true });
  }

  /* ---------------------------------------------------------- announcement bar: one message at a time */
  function ann() {
    var bar = $("[data-sc2-ann]"); if (!bar || bar.dataset.bound) return; bar.dataset.bound = 1;
    var grp = $(".sc2-ann__grp", bar);
    if (grp) { /* ticker: same speed (px/s) on every screen width */
      var px = +bar.dataset.px || 40, fit = function () { bar.style.setProperty("--ann-dur", Math.max(8, grp.offsetWidth / px) + "s"); };
      fit(); addEventListener("resize", fit); document.fonts && document.fonts.ready.then(fit);
      return;
    }
    var ms = $$(".sc2-ann__m", bar); if (ms.length < 2) return;
    var i = 0, sp = (+bar.dataset.speed || 4) * 1000, paused = false;
    bar.addEventListener("mouseenter", function () { paused = true; }); bar.addEventListener("mouseleave", function () { paused = false; });
    setInterval(function () { if (paused || document.hidden) return; ms[i].classList.remove("is-on"); i = (i + 1) % ms.length; ms[i].classList.add("is-on"); }, sp);
  }

  /* ---------------------------------------------------------- sheet (menu) */
  var opener = null;
  function openSheet(sel, focusSearch) {
    var s = $(sel); if (!s) return;
    opener = document.activeElement;
    s.classList.add("is-open", "was-open"); s.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("sc2-lock");
    setTimeout(function () { var f = focusSearch ? $("input[type=search]", s) : $("[data-sc2-close]", s); f && f.focus(); }, 80);
  }
  function closeSheets() {
    $$(".sc2-sheet.is-open").forEach(function (s) { s.classList.remove("is-open"); s.setAttribute("aria-hidden", "true"); });
    document.documentElement.classList.remove("sc2-lock");
    if (opener && opener.focus) opener.focus();
  }
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-sc2-open]");
    if (o) { e.preventDefault(); openSheet(o.getAttribute("data-sc2-open"), o.hasAttribute("data-sc2-search")); return; }
    if (e.target.closest("[data-sc2-close]")) closeSheets();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSheets(); });
  /* scroll story: tap 1 · 2 · 3 · 4 to jump to that chapter */
  document.addEventListener("click", function (e) {
    var st = e.target.closest("[data-sc2-step]"); if (!st) return;
    var s = st.closest("[data-sc2-story]"); if (!s) return;
    var n = +s.dataset.sc2Story || 1, i = +st.dataset.sc2Step;
    var top = s.getBoundingClientRect().top + scrollY, run = Math.max(1, s.offsetHeight - innerHeight);
    scrollTo({ top: top + run * Math.min(0.995, (i + 0.62) / n), behavior: RM ? "auto" : "smooth" });
  });
  /* read more / less */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-sc2-more]"); if (!b) return;
    var t = $(b.getAttribute("data-sc2-more")); if (!t) return;
    var open = t.classList.toggle("is-clamped") === false;
    b.setAttribute("aria-expanded", open);
    if (!b.dataset.more) b.dataset.more = b.textContent;
    b.textContent = open ? b.dataset.less : b.dataset.more;
  });

  /* ---------------------------------------------------------- reveal */
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
  }, { rootMargin: "0px 0px -8% 0px" }) : null;
  function reveal(scope) {
    $$("[data-sc2-reveal]:not(.is-in)", scope).forEach(function (el) { if (!io || RM || EDIT) el.classList.add("is-in"); else io.observe(el); });
  }

  /* ---------------------------------------------------------- on-screen flag (decorative loops only run while visible, after load) */
  var vio = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { en.target.classList.toggle("is-vis", en.isIntersecting); });
  }, { rootMargin: "100px 0px" }) : null;
  function visible(scope) { $$(".sc2-s, .sc2-foot", scope).forEach(function (el) { if (vio) vio.observe(el); else el.classList.add("is-vis"); }); }
  addEventListener("load", function () { setTimeout(function () { document.documentElement.classList.add("sc2-run"); }, RM ? 0 : 1200); });

  /* ---------------------------------------------------------- hero intro */
  function intro(scope) {
    $$("[data-sc2-split]", scope).forEach(function (h) {
      if (h.dataset.split) return; h.dataset.split = 1;
      $$(".ln", h).forEach(function (ln, li) {
        var words = ln.textContent.trim().split(/\s+/);
        ln.innerHTML = words.map(function (w) { return '<span class="w">' + w.replace(/[<>&]/g, "") + "</span>"; }).join(" ");
        $$(".w", ln).forEach(function (w, i) { setTimeout(function () { w.classList.add("is-in"); }, RM || EDIT ? 0 : (li ? 1350 : 850) + i * 110); });
      });
    });
    $$("[data-sc2-draw] path", scope).forEach(function (p) { try { p.style.setProperty("--len", Math.ceil(p.getTotalLength()) + 1); } catch (e) {} });
    $$("[data-sc2-intro]", scope).forEach(function (el) { setTimeout(function () { el.classList.add("is-in"); }, RM || EDIT ? 0 : +(el.dataset.d || 0)); });
  }

  /* ---------------------------------------------------------- scroll story */
  var stories = [];
  function story(scope) {
    $$("[data-sc2-story]", scope).forEach(function (s) {
      if (s.dataset.bound) return; s.dataset.bound = 1;
      stories.push({ s: s, kids: $$("[data-ci]", s), n: +s.dataset.sc2Story || 1, heat: 0 });
      var cv = $("canvas", s), rec = stories[stories.length - 1];
      if (cv && !RM) embers(cv, function () { return rec.heat; }, function () { return s.classList.contains("is-vis"); });
    });
    runStories();
  }
  function runStories() {
    stories.forEach(function (o) {
      var r = o.s.getBoundingClientRect(); if (!r.height) return;
      var p = clamp(-r.top / Math.max(1, r.height - innerHeight), 0, 1), c = p * o.n, idx = Math.min(o.n - 1, Math.floor(c));
      if (o.s.dataset.ch !== String(idx + 1)) o.s.dataset.ch = idx + 1;
      o.kids.forEach(function (el) {
        var i = +el.dataset.ci;
        el.style.setProperty("--lp", clamp(c - i, 0, 1).toFixed(4));
        el.classList.toggle("on", i === idx);
      });
      var fire = +(o.s.dataset.fire || 2);
      o.heat = idx === fire ? Math.min(1, c - fire) : 0;
    });
  }
  var ticking = false;
  addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { runStories(); ticking = false; }); } }, { passive: true });
  addEventListener("resize", runStories);
  function embers(canvas, intensity, onScreen) {
    var ctx = canvas.getContext("2d"), C = ["#FFB347", "#FF8A2A", "#FFD27A", "#E9A21B"], W = 0, H = 0, dpr = Math.min(2, devicePixelRatio || 1), P = [];
    var size = function () { W = canvas.clientWidth; H = canvas.clientHeight; canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    size(); addEventListener("resize", size);
    var sleeping = false;
    var wake = function () { if (sleeping) { sleeping = false; requestAnimationFrame(tick); } };
    addEventListener("scroll", wake, { passive: true });
    function tick() {
      if (onScreen && !onScreen() && !P.length) { sleeping = true; return; }
      var k = clamp(intensity(), 0, 1);
      if (k > 0.01) for (var i = 0; i < Math.round(k * 4); i++) P.push({ x: Math.random() * W, y: H + 10, vx: (Math.random() - .5) * .6, vy: -(0.7 + Math.random() * 1.8), r: .8 + Math.random() * 2.4, life: 0, max: 120 + Math.random() * 160, c: C[(Math.random() * 4) | 0] });
      if (P.length || k > 0.01) {
        ctx.clearRect(0, 0, W, H); ctx.globalCompositeOperation = "lighter";
        for (var j = P.length - 1; j >= 0; j--) {
          var p = P[j]; p.life++; p.x += p.vx + Math.sin((p.life + j) * .05) * .35; p.y += p.vy;
          var a = (1 - p.life / p.max) * (0.35 + k * 0.65);
          if (a <= 0 || p.y < -10) { P.splice(j, 1); continue; }
          ctx.globalAlpha = a; ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        }
        ctx.globalAlpha = 1;
      }
      if (k <= 0.01 && !P.length) { sleeping = true; return; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------------------------------------------------------- tabs (shop pills) */
  function tabs(scope) {
    $$("[data-sc2-tabs]", scope).forEach(function (t) {
      if (t.dataset.bound) return; t.dataset.bound = 1;
      t.addEventListener("click", function (e) {
        var b = e.target.closest("[data-tab]"); if (!b) return;
        $$("[data-tab]", t).forEach(function (x) { var on = x === b; x.classList.toggle("is-on", on); x.setAttribute("aria-selected", on); });
        $$("[data-panel]", t).forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.tab; if (!p.hidden) loadPanel(p); reveal(p); });
        b.scrollIntoView({ behavior: RM ? "auto" : "smooth", inline: "center", block: "nearest" });
      });
    });
  }

  function loadPanel(p) {
    var src = p.getAttribute("data-src"); if (!src || p.dataset.loaded) return;
    p.dataset.loaded = 1; var grid = $(".sc2-grid", p); p.classList.add("is-loading");
    fetch(src, { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var d = document.createElement("div"); d.innerHTML = html; var g = $(".sc2-grid", d);
      if (g && grid) { var per = +p.dataset.per || 8; $$(".sc2-card", g).slice(per).forEach(function (c) { c.remove(); }); grid.innerHTML = g.innerHTML; } p.classList.remove("is-loading"); reveal(p); lift(p);
    }).catch(function () { p.classList.remove("is-loading"); var a = $(".sc2-more a", p); if (a && grid && !grid.children.length) location.href = a.href; });
  }
  /* warm the next tabs once the page is idle, so a tap feels instant */
  addEventListener("load", function () {
    var go = function () { $$("[data-panel][data-src]").slice(0, 3).forEach(function (p) { if (p.hidden) { var l = document.createElement("link"); l.rel = "prefetch"; l.href = p.getAttribute("data-src"); document.head.appendChild(l); } }); };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 3000);
  });

  /* ---------------------------------------------------------- cart */
  function setCount(n) {
    $$("[data-sc2-count]").forEach(function (c) { c.textContent = n; c.dataset.count = n; });
    $$(".cart-link__bubble-num").forEach(function (c) { c.textContent = n; });
  }
  function refreshCount() { return fetch(root + "cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }).catch(function () {}); }
  /* apps (Shiprocket smart cart) change the cart with fetch too — keep our count honest */
  if (window.fetch && !window.fetch.sc2) {
    var of = window.fetch;
    window.fetch = function (u) {
      var url = typeof u === "string" ? u : (u && u.url) || "";
      return of.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(refreshCount, 60);
        return res;
      });
    };
    window.fetch.sc2 = 1;
  }
  function openCart() {
    /* Shiprocket smart cart (app embed) and Expanse both listen for these; if neither opens, we go to /cart */
    document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }));
    var trig = $("#HeaderCartTrigger");
    if (trig && trig.dataset.sc2Opens === "app") trig.click();
  }
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("form[data-sc2-add]"); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector("[type=submit]"), lab = btn && btn.querySelector("[data-label]");
    if (btn) btn.disabled = true;
    fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(f), credentials: "same-origin" })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        return refreshCount().then(function () {
          if (btn) { btn.classList.add("is-added"); if (lab) { lab.dataset.was = lab.dataset.was || lab.textContent; lab.textContent = lab.dataset.added || lab.textContent; } }
          var fab = $(".sc2-bagfab"); if (fab) { fab.classList.add("is-bump"); setTimeout(function () { fab.classList.remove("is-bump"); }, 380); }
          setTimeout(function () { if (btn) { btn.classList.remove("is-added"); if (lab && lab.dataset.was) lab.textContent = lab.dataset.was; } }, 1800);
          if (f.dataset.sc2Add === "checkout") location.href = root + "checkout"; else openCart();
        });
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || "Could not add to bag.";
        var out = f.querySelector("[data-sc2-error]"); if (out) { out.textContent = msg; out.hidden = false; } else alert(msg);
      })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------------------------------------------------------- product page */
  function pdp(scope) {
    $$("[data-sc2-pdp]", scope).forEach(function (P) {
      if (P.dataset.bound) return; P.dataset.bound = 1;
      /* gallery */
      var slides = $$(".sc2-main__slide", P), th = $$(".sc2-thumbs button", P), track = $("[data-sc2-track]", P), cur = -1;
      /* phone dots */
      var dots = null;
      if (track && slides.length > 1) { dots = document.createElement("div"); dots.className = "sc2-dots"; dots.innerHTML = slides.map(function () { return "<i></i>"; }).join(""); track.parentNode.appendChild(dots); }
      var mark = function (i) {
        if (i === cur) return; cur = i;
        slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
        th.forEach(function (b, k) { b.classList.toggle("is-on", k === i); b.setAttribute("aria-current", k === i); if (k === i && b.scrollIntoView && th.length > 4) b.parentNode.scrollTo({ left: b.offsetLeft - b.parentNode.clientWidth / 2 + b.offsetWidth / 2, behavior: "smooth" }); });
        if (dots) $$("i", dots).forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
      };
      var show = function (i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: RM ? "auto" : "smooth" }); mark(i); };
      var thumbsBox = th.length ? th[0].parentNode : null;
      if (thumbsBox) thumbsBox.addEventListener("click", function (e) { var b = e.target.closest("button"); if (!b) return; var k = th.indexOf(b); if (k > -1) show(k); });
      /* colour products: keep only the picked colour's photos (mood shot first) + shared cards */
      var allSlides = slides.slice(), allTh = th.slice(), starts = [];
      var regroup = function (mediaId) {
        if (!P.hasAttribute("data-colour-groups") || !track || !mediaId) return false;
        if (!starts.length) { var vj = $("[data-sc2-variants]", P); (vj ? JSON.parse(vj.textContent) : []).forEach(function (x) { if (x.featured_media) { var k = allSlides.findIndex(function (s) { return s.dataset.mediaId == x.featured_media.id; }); if (k > -1 && starts.indexOf(k) < 0) starts.push(k); } }); starts.sort(function (a, b) { return a - b; }); }
        var at = allSlides.findIndex(function (s) { return s.dataset.mediaId == mediaId; }); if (at < 0 || starts.indexOf(at) < 0) return false;
        var end = starts[starts.indexOf(at) + 1] || allSlides.length;
        var pick = [], pre = [], cards = [];
        allSlides.forEach(function (s, k) { if (s.hasAttribute("data-shared")) cards.push(k); else if (k >= at && k < end) pick.push(k); else if (k < starts[0]) pre.push(k); });
        var order = pick.concat(pre, cards);
        allSlides.forEach(function (s) { s.hidden = true; }); allTh.forEach(function (b) { b.hidden = true; });
        order.forEach(function (k) { var s = allSlides[k]; s.hidden = false; track.appendChild(s); if (allTh[k]) { allTh[k].hidden = false; thumbsBox && thumbsBox.appendChild(allTh[k]); } });
        allSlides.forEach(function (s) { if (s.hidden) track.appendChild(s); });
        slides = order.map(function (k) { return allSlides[k]; }); th = order.map(function (k) { return allTh[k]; }).filter(Boolean);
        if (dots) dots.innerHTML = slides.map(function () { return "<i></i>"; }).join("");
        cur = -1; track.style.scrollBehavior = "auto"; track.scrollLeft = 0; track.style.scrollBehavior = ""; mark(0);
        return true;
      };
      if (track) {
        var st = false;
        track.addEventListener("scroll", function () { if (st) return; st = true; requestAnimationFrame(function () { st = false; mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }); }, { passive: true });
        track.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") show(Math.min(slides.length - 1, cur + 1)); if (e.key === "ArrowLeft") show(Math.max(0, cur - 1)); });
        var first = slides.findIndex(function (s) { return s.classList.contains("is-on"); });
        if (first > 0) { track.style.scrollBehavior = "auto"; track.scrollLeft = first * track.clientWidth; track.style.scrollBehavior = ""; }
        mark(Math.max(0, first));
        var on0 = slides[Math.max(0, first)]; if (on0) regroup(on0.dataset.mediaId);
      }
      /* zoom: "+" or tap the photo -> full-screen viewer (swipe, arrows, tap/click to zoom, pinch on phones) */
      var zoomBtn = $("[data-sc2-zoom]", P);
      var openLB = function (start) {
        var srcs = slides.map(function (sl) { var im = $("img", sl); return im ? (im.getAttribute("data-zoom") || im.currentSrc || im.src) : null; }).filter(Boolean);
        if (!srcs.length) return;
        var lb = document.createElement("div"); lb.className = "sc2-lb"; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true");
        var ic = function (n) { return '<svg class="sc2-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">' + n + "</svg>"; };
        lb.innerHTML = '<div class="sc2-lb__bar"><span class="sc2-lb__n"></span><button type="button" aria-label="Close">' + ic('<path d="M5 5l14 14M19 5L5 19"/>') + '</button></div><div class="sc2-lb__track">' +
          srcs.map(function (u) { return '<div class="sc2-lb__slide"><img src="' + u + '" alt="" draggable="false"></div>'; }).join("") + "</div>" +
          '<button type="button" class="sc2-lb__nav prev" aria-label="Previous">' + ic('<path d="M5 12h14M13 6l6 6-6 6"/>') + '</button><button type="button" class="sc2-lb__nav next" aria-label="Next">' + ic('<path d="M5 12h14M13 6l6 6-6 6"/>') + "</button>";
        document.body.appendChild(lb);
        var tr = $(".sc2-lb__track", lb), n = $(".sc2-lb__n", lb), at = start;
        var setN = function () { n.textContent = (at + 1) + " / " + srcs.length; };
        var go = function (i) { at = Math.max(0, Math.min(srcs.length - 1, i)); tr.scrollTo({ left: at * tr.clientWidth, behavior: "smooth" }); setN(); };
        tr.addEventListener("scroll", function () { at = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); setN(); }, { passive: true });
        $$(".sc2-lb__slide img", lb).forEach(function (im) {
          im.addEventListener("click", function (e) {
            var sl = im.parentNode, on = !sl.classList.contains("is-zoomed"), r = im.getBoundingClientRect();
            im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
            sl.classList.toggle("is-zoomed", on); tr.style.overflowX = on ? "hidden" : "";
          });
          im.addEventListener("mousemove", function (e) { if (!im.parentNode.classList.contains("is-zoomed")) return; var r = im.parentNode.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%"; });
        });
        var key;
        var close = function () { lb.classList.remove("is-open"); document.documentElement.classList.remove("sc2-lock"); document.removeEventListener("keydown", key); setTimeout(function () { lb.remove(); }, 260); if (zoomBtn) zoomBtn.focus(); };
        key = function (e) { if (e.key === "Escape") close(); if (e.key === "ArrowRight") go(at + 1); if (e.key === "ArrowLeft") go(at - 1); };
        document.addEventListener("keydown", key);
        $(".sc2-lb__bar button", lb).addEventListener("click", close);
        $(".sc2-lb__nav.prev", lb).addEventListener("click", function () { go(at - 1); });
        $(".sc2-lb__nav.next", lb).addEventListener("click", function () { go(at + 1); });
        document.documentElement.classList.add("sc2-lock");
        requestAnimationFrame(function () { lb.classList.add("is-open"); tr.scrollLeft = start * tr.clientWidth; setN(); $(".sc2-lb__bar button", lb).focus(); });
      };
      if (zoomBtn) zoomBtn.addEventListener("click", function () { openLB(Math.max(0, cur)); });
      slides.forEach(function (sl, k) { var im = $("img", sl); if (im) im.addEventListener("click", function () { openLB(k); }); });
      /* qty */
      $$("[data-q]", P).forEach(function (b) {
        b.addEventListener("click", function () {
          var inp = $("[data-sc2-qty]", P); if (!inp) return;
          inp.value = clamp((+inp.value || 1) + +b.dataset.q, 1, +inp.max || 99);
        });
      });
      /* accordion */
      $$("[data-sc2-acc]", P).forEach(function (b) { b.addEventListener("click", function () { b.setAttribute("aria-expanded", b.getAttribute("aria-expanded") !== "true"); }); });
      /* options → variant */
      var json = $("[data-sc2-variants]", P), variants = json ? JSON.parse(json.textContent) : [];
      var idIn = $("form[data-sc2-add] input[name=id]", P), atc = $(".sc2-atc", P);
      var money = function (c) { return "₹" + (c / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 }); };
      var pick = function () {
        var sel = $$(".sc2-opt", P).map(function (fs) { var c = $("input:checked", fs); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { if (atc) { atc.disabled = true; } return; }
        if (idIn) idIn.value = v.id;
        $$("[data-sc2-price]", P).forEach(function (e) { e.textContent = money(v.price); });
        $$("[data-sc2-compare]", P).forEach(function (e) { e.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ""; e.hidden = !(v.compare_at_price > v.price); });
        $$("[data-sc2-off]", P).forEach(function (e) { var on = v.compare_at_price > v.price; e.hidden = !on; if (on) e.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + (e.dataset.suffix || "% off"); });
        if (atc) { atc.disabled = !v.available; var l = $("[data-label]", atc); if (l) l.textContent = v.available ? l.dataset.buy : l.dataset.sold; }
        if (v.featured_media && slides.length && !regroup(v.featured_media.id)) { var k = slides.findIndex(function (s) { return s.dataset.mediaId == v.featured_media.id; }); if (k > -1) show(k); }
        if (!EDIT && history.replaceState) { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u.toString()); }
      };
      $$(".sc2-opt input", P).forEach(function (i) { i.addEventListener("change", pick); });
      /* USP 07: take the first photo shot on a plain light background, cut the piece out of it in the browser
         (background → transparent, trimmed to the piece) so it stands to scale beside the A4 sheet */
      $$("[data-sc2-scale]", P).forEach(function (box) {
        var img = $("img", box), urls = (box.getAttribute("data-cands") || "").split("|").filter(Boolean);
        if (!img || !urls.length) return;
        var cut = function (t) {
          var w = t.naturalWidth, h = t.naturalHeight, c = document.createElement("canvas"); c.width = w; c.height = h;
          var x = c.getContext("2d", { willReadFrequently: true }); x.drawImage(t, 0, 0);
          var d = x.getImageData(0, 0, w, h), a = d.data;
          var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [w >> 1, 1], [1, h >> 1], [w - 2, h >> 1]], bg = [0, 0, 0];
          var px = pts.map(function (q) { var k = (q[1] * w + q[0]) * 4; return [a[k], a[k + 1], a[k + 2]]; });
          px.forEach(function (v) { bg[0] += v[0] / px.length; bg[1] += v[1] / px.length; bg[2] += v[2] / px.length; });
          var plain = Math.min(bg[0], bg[1], bg[2]) > 200 && px.every(function (v) { return Math.abs(v[0] - bg[0]) < 16 && Math.abs(v[1] - bg[1]) < 16 && Math.abs(v[2] - bg[2]) < 16; });
          if (!plain && !box.hasAttribute("data-picked")) return null; /* 12 Oct: a hand-picked size_photo is always cut */
          var x0 = w, y0 = h, x1 = 0, y1 = 0;
          for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) {
            var k = (y * w + i) * 4, dd = Math.max(Math.abs(a[k] - bg[0]), Math.abs(a[k + 1] - bg[1]), Math.abs(a[k + 2] - bg[2]));
            var al = dd < 12 ? 0 : dd < 38 ? Math.round((dd - 12) / 26 * 255) : 255; a[k + 3] = al;
            if (al > 60) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          if (x1 <= x0 || y1 <= y0) return null;
          x.putImageData(d, 0, 0);
          var o = document.createElement("canvas"); o.width = x1 - x0 + 1; o.height = y1 - y0 + 1;
          o.getContext("2d").drawImage(c, x0, y0, o.width, o.height, 0, 0, o.width, o.height);
          return o.toDataURL("image/png");
        };
        var pick = function (i) {
          if (i >= urls.length) { box.style.visibility = "hidden"; return; }
          var t = new Image(); t.crossOrigin = "anonymous";
          t.onload = function () { var u = null; try { u = cut(t); } catch (e) {} if (u) { img.onload = function () { img.classList.add("is-in"); }; img.src = u; } else pick(i + 1); };
          t.onerror = function () { pick(i + 1); };
          t.src = urls[i];
        };
        if ("IntersectionObserver" in window) { var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { o.disconnect(); pick(0); } }, { rootMargin: "300px" }); o.observe(box); } else pick(0);
      });
      /* sticky bar */
      var bar = $(".sc2-pbar", P);
      if (bar && atc && "IntersectionObserver" in window) {
        new IntersectionObserver(function (es) { var e = es[0]; bar.classList.toggle("is-on", !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(atc);
        var bb = $("button", bar); bb && bb.addEventListener("click", function () { atc.click(); });
      }
      /* pincode note (honest: we do not look the pincode up — the courier date is shown at checkout) */
      $$("[data-sc2-pin]", P).forEach(function (f) {
        f.addEventListener("submit", function (e) {
          e.preventDefault();
          var v = ($("input", f).value || "").trim(), r = $(".sc2-pin__res", f.parentNode), ok = /^[1-9]\d{5}$/.test(v);
          r.hidden = false; r.classList.toggle("is-bad", !ok);
          r.textContent = ok ? (f.dataset.ok || "").replace("{pincode}", v) : f.dataset.bad;
        });
      });
    });
  }

  /* ---------------------------------------------------------- collection filters (all client-side, instant, live counts) */
  function filters(scope) {
    $$("[data-sc2-filter]", scope).forEach(function (F) {
      if (F.dataset.bound) return; F.dataset.bound = 1;
      var grid = $("[data-fx-grid]", F), cards = $$(".sc2-card[data-i]", grid), side = $(".sc2-fx", F);
      var pmin = $("[data-fx-pmin]", F), pmax = $("[data-fx-pmax]", F), stock = $("[data-fx-stock]", F), sort = $("[data-fx-sort]", F);
      var boxes = $$("input[data-fx]", F), bands = $$("[data-fx-band]", F);
      var inBand = function (inch, v) { var r = v.split("-"), lo = +r[0], hi = +r[1]; return inch > 0 && inch > lo - (lo ? 0 : 1) && (hi >= 999 ? true : inch <= hi) && inch >= lo; };
      var state = function () {
        var st = { craft: [], mat: [], type: [], size: [], lo: +pmin.value || 0, hi: +pmax.value || 0, stock: stock && stock.checked };
        boxes.forEach(function (b) { if (b.checked) st[b.dataset.fx].push(b.value); });
        return st;
      };
      var match = function (c, st, skip) {
        var d = c.dataset, pr = +d.price;
        if (skip !== "price" && ((st.lo && pr < st.lo) || (st.hi && pr > st.hi))) return false;
        if (skip !== "stock" && st.stock && d.stock !== "true") return false;
        if (skip !== "craft" && st.craft.length && st.craft.indexOf(d.craft) < 0) return false;
        if (skip !== "mat" && st.mat.length && st.mat.indexOf(d.mat) < 0) return false;
        if (skip !== "type" && st.type.length && st.type.indexOf(d.type) < 0) return false;
        if (skip !== "size" && st.size.length && !st.size.some(function (v) { return inBand(+d.inch, v); })) return false;
        return true;
      };
      var apply = function (push) {
        var st = state(), shown = 0;
        cards.forEach(function (c) { var ok = match(c, st); c.hidden = !ok; if (ok) shown++; });
        boxes.forEach(function (b) {
          var key = b.dataset.fx, n = cards.filter(function (c) { if (!match(c, st, key)) return false; var d = c.dataset; return key === "size" ? inBand(+d.inch, b.value) : d[key] === b.value; }).length;
          var em = b.parentNode.querySelector("em"); if (em) em.textContent = n; b.parentNode.classList.toggle("is-zero", !n && !b.checked);
        });
        if (stock) { var em = stock.parentNode.querySelector("em"); if (em) em.textContent = cards.filter(function (c) { return match(c, st, "stock") && c.dataset.stock === "true"; }).length; }
        bands.forEach(function (bt) { var r = bt.dataset.fxBand.split("-"); bt.classList.toggle("is-on", st.lo === +r[0] && st.hi === +r[1]); });
        $$("[data-fx-shown], [data-fx-total]", F).forEach(function (e) { e.textContent = e.hasAttribute("data-fx-total") ? "(" + shown + ")" : shown; });
        var none = $("[data-fx-none]", F); if (none) none.hidden = shown > 0;
        /* chips + badge */
        var chips = [], act = 0;
        ["craft", "mat", "type", "size"].forEach(function (k) { st[k].forEach(function (v) { act++; var lab = k === "size" ? (boxes.find(function (b) { return b.dataset.fx === "size" && b.value === v; }) || {}).parentNode : null; chips.push({ k: k, v: v, t: lab ? $("span", lab).textContent : v }); }); });
        if (st.lo || st.hi) { act++; chips.push({ k: "price", t: "₹" + (st.lo || 0) + " – " + (st.hi ? "₹" + st.hi : "more") }); }
        if (st.stock) { act++; chips.push({ k: "stock", t: $("span", stock.parentNode).textContent }); }
        var wrap = $("[data-fx-chips]", F);
        wrap.innerHTML = chips.map(function (c, i) { return '<button type="button" data-chip="' + i + '">' + c.t.replace(/[<>&]/g, "") + "</button>"; }).join("");
        $$("button", wrap).forEach(function (bt) { bt.onclick = function () { var c = chips[+bt.dataset.chip];
          if (c.k === "price") { pmin.value = ""; pmax.value = ""; } else if (c.k === "stock") stock.checked = false;
          else boxes.forEach(function (b) { if (b.dataset.fx === c.k && b.value === c.v) b.checked = false; });
          apply(true); }; });
        var badge = $("[data-fx-active]", F); if (badge) { badge.hidden = !act; badge.textContent = act; }
        if (push && history.replaceState) {
          var u = new URL(location.href); ["craft", "mat", "type", "size", "min", "max", "stock"].forEach(function (k) { u.searchParams.delete(k); });
          ["craft", "mat", "type", "size"].forEach(function (k) { if (st[k].length) u.searchParams.set(k, st[k].join("|")); });
          if (st.lo) u.searchParams.set("min", st.lo); if (st.hi) u.searchParams.set("max", st.hi); if (st.stock) u.searchParams.set("stock", 1);
          history.replaceState(null, "", u.toString());
        }
      };
      var doSort = function () {
        var v = sort.value, list = cards.slice();
        var key = { "price-asc": function (a, b) { return a.dataset.price - b.dataset.price; }, "price-desc": function (a, b) { return b.dataset.price - a.dataset.price; },
          "new": function (a, b) { return b.dataset.new - a.dataset.new; }, "az": function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); } }[v] || function (a, b) { return a.dataset.i - b.dataset.i; };
        list.sort(key).forEach(function (c) { grid.appendChild(c); });
      };
      /* restore from the address */
      var q = new URL(location.href).searchParams;
      ["craft", "mat", "type", "size"].forEach(function (k) { var v = q.get(k); if (v) v.split("|").forEach(function (x) { boxes.forEach(function (b) { if (b.dataset.fx === k && b.value === x) b.checked = true; }); }); });
      if (q.get("min")) pmin.value = q.get("min"); if (q.get("max")) pmax.value = q.get("max"); if (q.get("stock") && stock) stock.checked = true;
      if (q.get("sort")) sort.value = q.get("sort"); else if (F.dataset.sortDefault) sort.value = F.dataset.sortDefault;
      boxes.forEach(function (b) { b.addEventListener("change", function () { apply(true); }); });
      if (stock) stock.addEventListener("change", function () { apply(true); });
      var t; [pmin, pmax].forEach(function (i) { i.addEventListener("input", function () { clearTimeout(t); t = setTimeout(function () { apply(true); }, 250); }); });
      bands.forEach(function (bt) { bt.addEventListener("click", function () { var r = bt.dataset.fxBand.split("-"); if (bt.classList.contains("is-on")) { pmin.value = ""; pmax.value = ""; } else { pmin.value = r[0] === "0" ? "" : r[0]; pmax.value = +r[1] > 999999 ? "" : r[1]; } apply(true); }); });
      sort.addEventListener("change", function () { doSort(); if (history.replaceState) { var u = new URL(location.href); u.searchParams.set("sort", sort.value); history.replaceState(null, "", u.toString()); } });
      $$("[data-fx-clear]", F).forEach(function (b) { b.addEventListener("click", function () { boxes.forEach(function (x) { x.checked = false; }); pmin.value = ""; pmax.value = ""; if (stock) stock.checked = false; apply(true); }); });
      $$("[data-fx-open]", F).forEach(function (b) { b.addEventListener("click", function () { side.classList.add("is-open"); document.documentElement.classList.add("sc2-lock"); }); });
      $$("[data-fx-close]", F).forEach(function (b) { b.addEventListener("click", function () { side.classList.remove("is-open"); document.documentElement.classList.remove("sc2-lock"); }); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && side.classList.contains("is-open")) { side.classList.remove("is-open"); document.documentElement.classList.remove("sc2-lock"); } });
      doSort(); apply(false);
    });
  }

  /* ---------------------------------------------------------- instant search (Shopify predictive search) */
  function suggest(scope) {
    $$("form[role=search] input[name=q]", scope).forEach(function (inp) {
      if (inp.dataset.sugg) return; inp.dataset.sugg = 1;
      var form = inp.form; form.classList.add("sc2-sugg"); inp.setAttribute("autocomplete", "off");
      var box = document.createElement("div"); box.className = "sc2-suggest"; box.hidden = true; box.setAttribute("role", "listbox");
      form.parentNode.insertBefore(box, form.nextSibling);
      var t, ctrl, sel = -1;
      var esc = function (x) { return String(x || "").replace(/[&<>"]/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]; }); };
      var rs = function (v) { var n = parseFloat(v); return isNaN(n) ? "" : "₹" + Math.round(n).toLocaleString("en-IN"); };
      var run = function () {
        var q = inp.value.trim(); if (q.length < 2) { box.hidden = true; box.innerHTML = ""; return; }
        if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        fetch(root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last", { signal: ctrl && ctrl.signal })
          .then(function (r) { return r.json(); }).then(function (j) {
            var R = (j.resources && j.resources.results) || {}, P = R.products || [], C = R.collections || [], h = "";
            if (P.length) {
              h += '<div class="sc2-suggest__h">Pieces</div>' + P.map(function (p) {
                var parts = (p.title || "").split(" | "), img = p.image || (p.featured_image && p.featured_image.url) || "";
                if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=120";
                return '<a class="p" role="option" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") +
                  "<span><b>" + esc(parts[0]) + "</b><small>" + esc(parts.slice(1).join(" · ") || p.type || "") + "</small></span><i>" + rs(p.price) + "</i></a>";
              }).join("");
            }
            if (C.length) h += '<div class="sc2-suggest__h">Collections</div><div class="sc2-suggest__cols">' + C.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + "</a>"; }).join("") + "</div>";
            if (!P.length && !C.length) h = '<div class="sc2-suggest__none">No pieces match “' + esc(q) + '” — try Nandi, deer or tea light.</div>';
            h += '<a class="sc2-suggest__all" href="' + root + "search?type=product&q=" + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” →</a>';
            box.innerHTML = h; box.hidden = false; sel = -1;
          }).catch(function () {});
      };
      inp.addEventListener("input", function () { clearTimeout(t); t = setTimeout(run, 180); });
      inp.addEventListener("focus", function () { if (box.innerHTML && inp.value.trim().length > 1) box.hidden = false; });
      inp.addEventListener("keydown", function (e) {
        var items = $$("a.p, .sc2-suggest__all", box); if (box.hidden || !items.length) return;
        if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); sel = (sel + (e.key === "ArrowDown" ? 1 : -1) + items.length) % items.length; items.forEach(function (x, i) { x.classList.toggle("is-on", i === sel); }); }
        else if (e.key === "Enter" && sel > -1) { e.preventDefault(); location.href = items[sel].href; }
        else if (e.key === "Escape") { box.hidden = true; }
      });
      document.addEventListener("click", function (e) { if (!form.contains(e.target) && !box.contains(e.target)) box.hidden = true; });
    });
  }

  /* ---------------------------------------------------------- boot */
  /* ---------------------------------------------------------- back to top */
  function totop() {
    var t = $("[data-sc2-totop]"); if (!t || t.dataset.bound) return; t.dataset.bound = 1;
    var on = false, tick = false;
    function upd() { tick = false; var v = window.scrollY > window.innerHeight * 1.2; if (v !== on) { on = v; t.classList.toggle("is-on", v); } }
    window.addEventListener("scroll", function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
    t.addEventListener("click", function () { var r = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches; window.scrollTo({ top: 0, behavior: r ? "auto" : "smooth" }); });
  }

  /* ---------------------------------------------------------- Shop by craft: arrows scroll two cards */
  function cats(scope) {
    $$("[data-sc2-cats]", scope).forEach(function (S) {
      if (S.dataset.bound) return; S.dataset.bound = 1;
      var row = $("[data-cats-row]", S); if (!row) return;
      var step = function (d) { var c = row.querySelector(".sc2-cat"); var w = c ? c.getBoundingClientRect().width + 14 : 240; row.scrollBy({ left: d * w * 2, behavior: "smooth" }); };
      var p = $("[data-cats-prev]", S), n = $("[data-cats-next]", S);
      if (p) p.addEventListener("click", function () { step(-1); });
      if (n) n.addEventListener("click", function () { step(1); });
    });
  }

  /* dark first photos: worked out once on the server side (snippets/sc2-lift-list.liquid), nothing to do here */
  function lift() {}

  /* ---------------------------------------------------------- Shiprocket BUY NOW placeholder (loader is deferred) */
  function srph(scope) {
    $$("[data-sc2-sr-ph]", scope).forEach(function (ph) {
      if (ph.dataset.bound) return; ph.dataset.bound = 1;
      var box = ph.parentNode;
      var real = function () { return $$(".sr-headless-checkout", box).filter(function (b) { return b !== ph; })[0]; };
      var tidy = function () { if (real() && ph.parentNode) ph.remove(); };
      if (window.MutationObserver) new MutationObserver(tidy).observe(box, { childList: true, subtree: true });
      ph.addEventListener("click", function () {
        ph.classList.add("is-wait");
        var fire = function () { var t = 0, iv = setInterval(function () { var r = real(); if (r) { clearInterval(iv); tidy(); r.click(); } else if (++t > 60) { clearInterval(iv); ph.classList.remove("is-wait"); } }, 100); };
        if (window.sc2LoadSR) window.sc2LoadSR(fire); else fire();
      });
    });
  }

  function init(scope) { header(); ann(); totop(); visible(scope); reveal(scope); intro(scope); story(scope); tabs(scope); pdp(scope); filters(scope); suggest(scope); cats(scope); lift(scope); srph(scope); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); refreshCount(); });
  else { init(document); refreshCount(); }
  addEventListener("pageshow", function (e) { if (e.persisted) refreshCount(); });
  document.addEventListener("shopify:section:load", function (e) { stories = stories.filter(function (o) { return document.body.contains(o.s); }); init(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var cp = e.target.closest("[data-ci]"), s = e.target.closest("[data-sc2-story]");
    if (cp && s) { s.dataset.ch = (+cp.dataset.ci) + 1; $$("[data-ci]", s).forEach(function (x) { x.classList.toggle("on", x.dataset.ci === cp.dataset.ci); x.style.setProperty("--lp", 1); }); }
    var tab = e.target.closest("[data-tab]"); if (tab) tab.click();
  });
})();

/* P85 slide-to-track: drag the truck past 75% to open tracking; a plain tap / Enter also opens (native link). */
(function () {
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches;
  var init = function () { document.querySelectorAll("[data-sc2-slide]").forEach(function (a) {
    if (a.dataset.sc2On) return; a.dataset.sc2On = 1;
    a.setAttribute("draggable", "false"); a.addEventListener("dragstart", function (e) { e.preventDefault(); }); /* a link is natively draggable: that cancelled the pointer drag */
    var th = a.querySelector(".sc2-slide__thumb"), sx = 0, x = 0, max = 0, on = false, moved = false;
    if (!th || RM) return;
    var set = function (v) { x = v; a.style.setProperty("--x", v + "px"); a.style.setProperty("--p", max ? v / max : 0); };
    th.addEventListener("pointerdown", function (e) {
      e.stopPropagation(); if (e.pointerType === "mouse") e.preventDefault(); on = true; moved = false; sx = e.clientX - x;
      max = a.clientWidth - th.offsetWidth - 8; a.classList.remove("is-back"); a.classList.add("is-drag");
      try { th.setPointerCapture(e.pointerId); } catch (_) {}
    });
    th.addEventListener("pointermove", function (e) {
      if (!on) return; e.stopPropagation(); e.preventDefault();
      var v = Math.max(0, Math.min(max, e.clientX - sx)); if (v > 4) moved = true; set(v);
    });
    var end = function (e) {
      if (!on) return; on = false; e.stopPropagation(); a.classList.remove("is-drag");
      if (max && x / max >= 0.75) {
        a.classList.add("is-go"); set(max);
        window.open(a.href, "_blank", "noopener");
        setTimeout(function () { a.classList.remove("is-go"); a.classList.add("is-back"); set(0); }, 1000);
      } else { a.classList.add("is-back"); set(0); }
    };
    th.addEventListener("pointerup", end); th.addEventListener("pointercancel", end);
    a.addEventListener("click", function (e) { if (moved) { e.preventDefault(); moved = false; } });
  }); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
